import React from 'react';
import { Container, Table } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import "../../Styles/yellowcalf.css/PaymentReceipt.css";

export default function PaymentReceipt () {
  const executePrintAction = () => {
    window.print();
  };

  return (
    <div className="billingPageWrapper my-4">
      <Container className="documentContainerMain">
        <div className="titleHeaderZone">
          <h1 className="mainDocumentHeading">Payment Receipt</h1>
        </div>

        <div className="contentAreaBlock">
          <Table bordered className="financialDataTable">
            <tbody>
              <tr className="primaryInfoRow">
                <td colSpan={2} className="labelFieldColumn">Payment Receipt</td>
                <td className="labelFieldColumn">Date</td>
                <td className="valueFieldColumn">Wed Apr 20 2022</td>
              </tr>
              
              <tr className="detailsInfoRow">
                <td className="labelFieldColumn">School Name</td>
                <td colSpan={3} className="valueFieldColumn">Demo school for development</td>
              </tr>
              
              <tr className="detailsInfoRow">
                <td className="labelFieldColumn">Identification Number</td>
                <td colSpan={3} className="valueFieldColumn">877_73554</td>
              </tr>
              
              <tr className="detailsInfoRow">
                <td className="labelFieldColumn">Payment Mode</td>
                <td className="valueFieldColumn">Paytm</td>
                <td className="labelFieldColumn">Paid for</td>
                <td className="valueFieldColumn">Service</td>
              </tr>
              
              <tr className="detailsInfoRow">
                <td className="labelFieldColumn">Description</td>
                <td className="valueFieldColumn">Invalid Order Id.</td>
                <td className="labelFieldColumn">Invoice Number</td>
                <td className="valueFieldColumn">877</td>
              </tr>
              
              <tr className="detailsInfoRow">
                <td className="labelFieldColumn"></td>
                <td className="valueFieldColumn"></td>
                <td className="labelFieldColumn">Amount</td>
                <td className="valueFieldColumn">$ 2700</td>
              </tr>
            </tbody>
          </Table>

          <div className="buttonControlArea">
            <button onClick={executePrintAction} className="printTriggerButton">
              Print
            </button>
          </div>
        </div>
      </Container>
    </div>
  );
}
